import { cn } from '@/lib/utils';

interface BrandMarkProps {
  className?: string;
}

/**
 * Master Balance logo: a circle split into two offset halves (navy and teal)
 * on a white rounded tile. Keep in sync with `public/favicon.svg`.
 */
export function BrandMark({ className }: BrandMarkProps) {
  return (
    <svg viewBox="0 0 48 48" role="img" aria-label="Master Balance" className={cn('h-9 w-9 shrink-0 rounded-[25%]', className)}>
      <rect width="48" height="48" rx="12" fill="#FFFFFF" />
      <path d="M8 23 A16 16 0 0 1 40 23 Z" transform="translate(-2.5 0)" fill="#174873" />
      <path d="M8 25 A16 16 0 0 0 40 25 Z" transform="translate(2.5 0)" fill="#2BB3A3" />
    </svg>
  );
}
